/**
 *
 * @module contentClientConfiguration
 *
 */

import ServiceClientConfiguration from './../configuration/serviceClientConfiguration';

/**
 *
 * @class ContentClientConfiguration
 * @extends {ServiceClientConfiguration}
 * @desc Provides configuration information used by the ContentClient
 *
 */
export default class ContentClientConfiguration extends ServiceClientConfiguration {

    /**
     *
     * @param {String} baseUrl
     * @param {Object} endpoints
     * @param {ContentClientExtrasMap} extras
     *
     */
    constructor(baseUrl, endpoints, extras) {

        super(baseUrl, endpoints);

        /**
         *
         * @access public
         * @type {ContentClientExtrasMap}
         * @desc Gets or sets the extra data needed by the client.
         *
         */
        this.extras = extras;

    }

}



// WEBPACK FOOTER //
// ./src/services/content/contentClientConfiguration.js